module.exports = __webpack_public_path__ + "static/img/wa01.0cf6b142.png";